module.exports = __webpack_public_path__ + "static/media/6MyHealth.43a7300c.JPG";